import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Time from './Time';
import UpdateInfo from './UpdateInfo';
import Divider from './Divider';
import YesterdayBanner from './YesterdayBanner';
import Foot from './Foot';
import TopColumn from './topColumn';
import ShareContext from './store/index.js';
import { getShareDataapi } from '@src/services/api';
// import transform from 'chipDataTransform';
// import ChipEdit from 'ChipEdit';
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';

const Layout = ({ content }) => {
    // 定义组件状态来存储异步数据
    const [shareData, setShareData] = useState(null);
    const isFromHws = window.location?.search?.includes('from=hms');

    useEffect(() => {
        // 定义异步函数，获取分享页面的全部数据
        const fetchData = async () => {
            try {
                const response = await getShareDataapi();

                // 分享页面打开统计
                pageStatistics({
                    behavior: 'page',
                    id: response.data.baseInfo.staticId,
                    ref: decodeURIComponent(document.referrer),
                    url: decodeURIComponent(location.href),
                });

                // 将异步数据存储在组件状态中
                setShareData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    if (!shareData) {
        // 如果数据还在加载中，可以返回一个 loading 界面或者空白
        return <div>Loading...</div>;
    }

    // 今天全部的的热点列表
    const todayList = shareData.todayList.items ? shareData.todayList.items : [];

    // 昨天二十四小时的热点列表
    const yesterdayInfo = shareData.yesterdayList;

    // 每个时间所对应的颜色
    const textcolor = {
        day: shareData.baseInfo.todayHighlightColor,
        yesterdayDay: shareData.baseInfo.yesterdayHighlightColor,
    };

    // 传入context的变量值
    const contextStore = {
        color: textcolor,
    };

    return (
        <ShareContext.Provider value={contextStore}>
            <QQShare
                content={{
                    title: shareData.shareInfo.shareTitle || '',
                    img: shareData.shareInfo.thumbnail || '',
                    desc: shareData.shareInfo.desc || '',
                    url: window.location.href,
                    cb: () => {
                        console.log('分享成功');
                    },
                }}
            />
            {
                isFromHws ? null : <TopColumn content={content} />
            }
            <Time timeInfo={shareData.baseInfo} />
            {todayList.map((item) => (
                <div key={item.blockId}>
                    <UpdateInfo hoursItem={item} isYesterday={false} />
                    <Divider endTime={item.endingText} />
                </div>
            ))}
            <YesterdayBanner title={yesterdayInfo?.title || ''} />
            {yesterdayInfo?.items?.map((item) => (
                <div key={item.blockId}>
                    <UpdateInfo hoursItem={item} isYesterday={true} />
                    <Divider endTime={item.endingText} />
                </div>
            ))}
            {/* <Foot content={content} /> */}

            {/* <ChipEdit transform={transform} /> */}
        </ShareContext.Provider>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
